export default "__VITE_ASSET__CvhcQqhz__"